module.exports = __webpack_public_path__ + "teqbahn-assets/media/mountain.c5c1e18f.png";